import ButtonComponent from "../../ButtonComponent";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { CloseCircleOutlined } from "@ant-design/icons";

const BoxAlert = ({ ...props }) => {
    const { t } = useTranslation();
    return (
        <div className="box-login-register-template box-register box-alert">
            {props.type !== "error" ? (
                <img src="/icon/ic-check.svg" alt="" srcSet="" />
            ) : (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70px" }}>
                    <CloseCircleOutlined style={{ fontSize: "48px", color: "red" }} />
                </div>
            )}
            <h2 dangerouslySetInnerHTML={{ __html: props.title }}></h2>
            <h3 dangerouslySetInnerHTML={{ __html: props.paragraph }}></h3>

            {props.action ? (
                <ButtonComponent
                    btnTitle={props.btnTitle ? props.btnTitle : t("btn_back_to_login")}
                    colorTitle="#fff"
                    colorBackground="#0000FF"
                    {...props}
                />
            ) : (
                <ButtonComponent
                    btnTitle={props.btnTitle ? props.btnTitle : t("btn_back_to_login")}
                    colorTitle="#fff"
                    colorBackground="#0000FF"
                    onClick={() => (window.location = props.link ? props.link : `/login`)}
                />
            )}
        </div>
    );
};

export default BoxAlert;
